let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("41VXJ")).then(() => parcelRequire('5gN3L'));